// Keep in sync with back-end benchling/analytics/lib/analytics_event.py

import {ActionMethod, ActionOrigin, AnalyticsMetadataForContext} from 'constants/AnalyticsConstants';

/**
 * The possible categories for an event.
 * Any events that make a change to the core database should be `write`
 * All other events should be `read`
 */
export enum ACTION_CATEGORY {
  READ = 'read',
  WRITE = 'write',
}

// Keep in sync with benchling/analytics/lib/core/analytics_event.py
export enum ANALYTICS_MODULE {
  ANALYSIS_TOOL = 'analysis_tool',
  AUDIT = 'audit',
  BENCHLING_APPS = 'benchling_apps',
  CAPILLARY = 'capillary',
  CHEMISTRY = 'chemistry',
  COLLABORATION = 'collaboration',
  CONFIG_MIGRATION = 'config_migration',
  CONNECT = 'CONNECT',
  DATA_FRAMES = 'data_frames',
  DATA_MANAGEMENT = 'data_management',
  DEEP_RESEARCH = 'deep_research',
  ELN = 'eln',
  EVENTS = 'events',
  FORMS = 'forms',
  GROWTH = 'growth',
  IDENTITY = 'identity',
  INSIGHTS = 'external_analytics',
  INSTRUMENTS = 'instruments',
  LEGACY_WORKFLOWS = 'workflows',
  MOLBIO = 'molbio',
  MODBIO = 'modified_biologics',
  NAVIGATION = 'navigation',
  PERMISSION_CONTROLS = 'permission_controls',
  PIPELINES = 'pipelines',
  PROCEDURES = 'procedures',
  PROJECT_FOLDER = 'project_folder',
  REGISTRY = 'bioregistry',
  REQUESTS = 'requests',
  REQUESTS_V2 = 'requests_v2',
  RESULTS = 'results',
  REVIEWS = 'reviews',
  SAMPLES = 'samples',
  SAMPLE_TESTS = 'sample_tests',
  SCHEMAS = 'schemas',
  SIGHTGLASS = 'sightglass',
  STUDIES = 'studies',
  TENANT_COMPARISON = 'tenant_comparison',
  UNITS = 'units',
  WORKFLOWS = 'workflows_v2',
  WORKLISTS = 'worklists',
  WORKSHEETS = 'worksheets',
  // For general events, use `trackEventWithModule` to provide a specific module
  MODULE_MISSING = 'module_missing',
}

export interface NormalizedAnalyticsEventMetadata {
  action_origin?: ActionOrigin;
  action_method?: ActionMethod;
  // TODO(TypeScript): Add more fields
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export type AnalyticsEventMetadata = NormalizedAnalyticsEventMetadata | AnalyticsMetadataForContext;
